import React, { useState, useEffect } from 'react';
import clsx from "clsx";
import customStyles from "../../../../assets/styles/customStyles";
import { CustomModal } from "../DeleteModal";
import { isDesktop } from "../../../../setup/desktopApi";

const NoInternetConnection = (props) => {
    const classes = customStyles();
    // The desktop build is offline-first: working without internet is supported,
    // so the blocking "No internet" modal must NOT appear there. Web is unchanged.
    const desktop = isDesktop();
    // state variable holds the state of the internet connection
    const [isOnline, setOnline] = useState(true);

    // On initialization set the isOnline state and subscribe to connectivity
    // changes (with cleanup — the listeners previously leaked on every render).
    useEffect(() => {
        if (desktop) return undefined; // never block on desktop
        setOnline(navigator.onLine);
        const goOnline = () => setOnline(true);
        const goOffline = () => setOnline(false);
        window.addEventListener('online', goOnline);
        window.addEventListener('offline', goOffline);
        return () => {
            window.removeEventListener('online', goOnline);
            window.removeEventListener('offline', goOffline);
        };
    }, [desktop]);

    // Desktop: render the app as-is, regardless of connectivity.
    if (desktop) {
        return <React.Fragment>{props.children}</React.Fragment>;
    }

    // Web: if user is online, render children; else overlay the block modal.
    return (
        <React.Fragment>
            {props.children}
            <CustomModal centered={true} onClose={() => { return false }}
                closeIcon={false}
                visible={!isOnline}
                text={
                    <div className={clsx(classes.textAlignCenter, classes.noInternetContainer)}>
                        <img src={props.img} alt={"No internet connection."} />
                        <p className={classes.noInternet}>Whoops</p>
                        <p>No internet connection, please check your internet settings.</p>
                    </div>
                } />
        </React.Fragment>
    )

}

export default NoInternetConnection;